@if (device && device.id) {
  <div>
    @if (!device.isMeter()) {
      <div>
        <mat-toolbar class="small-bar">
          <span>Datapoints</span>
          <span class="toolbar-spacer"></span>
          <button mat-raised-button color="primary" (click)="onClickDialogBtn()">Create datapoint</button>
        </mat-toolbar>
        @if (device.datapointList.length) {
          <table class="table">
            <thead>
              <tr>
                <th>Measure</th>
                <th>Period (int)</th>
                <th>Unit</th>
                <th>Módosítva</th>
                <th>Módosította</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (datapoint of device.datapointList; track datapoint) {
                <tr>
                  <td>{{datapoint.measureName}}</td>
                  <td>{{datapoint.period}}</td>
                  <td>{{datapoint.unit}}</td>
                  <td>{{datapoint.modified}}</td>
                  <td>{{datapoint.modifiedBy}}</td>
                  <td class="text-end">
                    <button type="button" mat-raised-button color="warn" (click)="onDeleteDatapointClick(datapoint)" >Törlés</button>
                    <button type="button" mat-raised-button color="primary" (click)="onEditDatapointClick(datapoint)" class="ms-2">Szerkesztés</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        @if (!device || !device.datapointList.length) {
          <p class="text-center p-3">
            No datapoints yet.
          </p>
        }
        @if (device && (device.isDatalogger() || device.isMeter())) {
          <div>
            <app-device-query [device]="device"></app-device-query>
          </div>
        }
      </div>
    }
  </div>
}
